import { Europafacts } from "@/services/api";
import type { CategoryStore } from "@/types/stores/category";
import { createAsyncLoader } from "@/utils/stores/asyncLoader";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  categories: [],
  isLoadingCategories: false,
  categoriesPromise: null,
};

export const useCategoryStore = create<CategoryStore>()(
  devtools(
    (set, get) => ({
      ...initialState,

      loadCategories: createAsyncLoader({
        loadFn: () => Europafacts.getCategories(),
        dataKey: "categories",
        loadingKey: "isLoadingCategories",
        promiseKey: "categoriesPromise",
        actionName: "category/loadCategories",
      })(set, get),
    }),
    {
      name: "category-store",
    }
  )
);

export const useCategories = () =>
  useCategoryStore((state) => state.categories);

export const useIsLoadingCategories = () =>
  useCategoryStore((state) => state.isLoadingCategories);

export const useLoadCategories = () =>
  useCategoryStore((state) => state.loadCategories);

